// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.forgot-password {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.forgot-password .card {
  box-shadow: 6px 7px 10px rgba(0, 0, 0, 0.3);
  border: 0px solid #c8ced3;
  border-radius: 1.25rem;
}
.forgot-password .logo img {
  width: 80%;
}
.forgot-password h5 {
  color: #808080;
  font-weight: 400;
}

.mat-form-field {
  margin-left: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/forgot/forgot.component.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;AACE;EACE,2CAAA;EACA,yBAAA;EACA,sBAAA;AACJ;AAEE;EACE,UAAA;AAAJ;AAGE;EACE,cAAA;EACA,gBAAA;AADJ;;AAKA;EACE,yBAAA;AAFF","sourcesContent":[".forgot-password {\r\n  min-height: 100vh;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n\r\n  .card {\r\n    box-shadow: 6px 7px 10px rgba(0, 0, 0, 0.3);\r\n    border: 0px solid #c8ced3;\r\n    border-radius: 1.25rem;\r\n  }\r\n\r\n  .logo img {\r\n    width: 80%;\r\n  }\r\n\r\n  h5 {\r\n    color: #808080;\r\n    font-weight: 400;\r\n  }\r\n}\r\n\r\n.mat-form-field {\r\n  margin-left: 0 !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
